import {
	CIMD_MCP_AGENT_JOB_TITLE,
	DCR3P_AGENT_JOB_TITLE,
} from '@atlassian/user-profile-card/agent-job-titles';

/** AGG's AppUser markers for third-party agents using the Atlassian MCP route. */
export const isMcpAgentJobTitle = (jobTitle?: string | null): boolean =>
	jobTitle === DCR3P_AGENT_JOB_TITLE || jobTitle === CIMD_MCP_AGENT_JOB_TITLE;
